import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  templateUrl: './not-found.page.html',
  standalone: true,
})
export class NotFoundPage {
  constructor(private readonly router: Router) {}

  routeToHome(): void {
    globalThis.window.location.replace(environment.productUrl);
  }
}
